import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import Container from "../../partials/container"
import { color } from "../../../components/colors"
import Button from "../../atoms/button"
import Icon from "../../atoms/icon"
import CircleSVG from "../../../images/circle-top.inline.svg"
import HexesSVG from "../../../images/hexes-top.inline.svg"
import Hexes2SVG from "../../../images/hexes-top-2.inline.svg"
import ImgElSVG from "../../../images/top-img-el.inline.svg"
import ImgEl2SVG from "../../../images/top-img-el-2.inline.svg"
import ImgEl3SVG from "../../../images/top-img-el-3.inline.svg"
import CrossSVG from "../../../images/cross.inline.svg"
import Heading from "../../atoms/section-title"
import Text from "../../atoms/text"
import { typography } from "../../../components/typography"

const HomepageTopSection = ({ data }) => (
  <Top id="home">
    {/* <Icon
      icon={<CircleSVG />}
      height="556px"
      width="740px"
      absolute
      top="89px"
      left="0"
    /> */}
    <ImageOverlay className="image-overlay">
      <Img fixed={data.zdjecieGlowneObraz.localFile.childImageSharp.fluid} />
    </ImageOverlay>
    <Overlay className="top-overlay">
      <Container className="top-content">
        <Content>
          <Heading
            size="1"
            mb="33px"
            color={color.primary60}
          >{`Radca prawny <br>Miłosz Chróściak`}</Heading>
          <Text typography={typography.bodyL} mb="64px">
            {`Radca prawny świadczący pomoc prawną dla osób fizycznych, oferujący kompleksowe wsparcie w różnych dziedzinach prawa. Prowadzę sprawy karne oraz karne skarbowe, wykorzystując doświadczenie zdobyte w Krajowej Administracji Skarbowej (Wieloosobowe Stanowisko Spraw Karnych Skarbowych), co pozwala mi skutecznie reprezentować klientów w trudnych sytuacjach.
            <br><br>Specjalizuję się w prawie rodzinnym, obejmującym sprawy rozwodowe, alimentacyjne, dotyczące władzy rodzicielskiej, kontaktów z dzieckiem oraz ustalenia miejsca pobytu dziecka.
            <br><br>Ponadto wspieram klientów w sprawach o odszkodowania i zadośćuczynienia, zapewniając rzetelną pomoc prawną na każdym etapie dochodzenia roszczeń. Prowadzę także sprawy związane z ZUS — pomagam w sporządzaniu odwołań od decyzji dotyczących emerytur i rent, a także od orzeczeń o niepełnosprawności, dążąc do jak najlepszego zabezpieczenia interesów moich klientów.
            <br><br>Relacje z klientami opieram na zaufaniu, dlatego zawsze staram się dobierać rozwiązania adekwatne do indywidualnych potrzeb każdej sprawy.
            `}
          </Text>
          <ButtonContainer>
            {/* <Button
              content={{
                text: "Nasz zespół",
                url: "/#zespol",
              }}
              p="12px 20px"
              pSM="14px 26px"
              pMD="16px 32px"
            /> */}
            <Button
              content={{
                text: "Umów konsultację",
                url: "/#kontakt",
              }}
              p="12px 20px"
              pSM="14px 26px"
              pMD="16px 32px"
              theme="secondary"
            />
          </ButtonContainer>
        </Content>
      </Container>
    </Overlay>
  </Top>
)

export default HomepageTopSection

const Top = styled.section`
  width: 100%;
  position: relative;
  //background-color: ${color.neutral20};
  background-color: ${color.white};
  overflow: hidden;
  min-height: 100vh;

  .custom-bg {
    padding-top: 89px;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;

    .gatsby-image-wrapper {
      display: block !important;
      width: 100%;
      height: 100%;
    }
  }
`

const ImageOverlay = styled.div`
  display: none;
  padding-top: 89px;
  height: 100%;
  width: 40%;
  position: absolute;
  right: 0;

  @media (min-width: 769px) {
    display: block;
  }

  .gatsby-image-wrapper {
    height: 100%;
    width: 100%;
    //max-width: 700px;
    background-color: ${color.primary40};

    img {
      object-position: center top !important;
    }
  }
`

const Overlay = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 89px;
  padding-bottom: 64px;
  position: relative;
  z-index: 1;

  .top-content {
    display: flex;
    justify-content: flex-start;
  }

  &.form-overlay {
    padding: 100px 0 60px;
    position: static;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;

  @media (min-width: 769px) {
    width: 60%;
    padding: 45px 40px 45px 0;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
`

const TopImage = styled.div`
  display: none;
  justify-content: center;
  align-items: flex-end;
  width: 50%;
  max-width: 570px;
  padding: 15px 0 125px 15px;
  position: relative;

  @media (min-width: 769px) {
    display: flex;
  }
`

const Shape = styled.div`
  width: 100%;
  background: linear-gradient(56.58deg, #d9f2e6 0%, #66cc99 100%);
  box-shadow: 16px 16px 32px rgba(0, 153, 76, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 1132px 1000px 1000px 24px;
  position: absolute;

  &::before {
    content: "";
    display: block;
    width: 100%;
    padding-top: 81.23%;
  }
`

const ImgEl = styled.div`
  width: 295px;
  height: 156px;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: 16px 16px 32px rgba(0, 153, 76, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  position: absolute;
  right: -5%;
  bottom: 75px;

  svg {
    margin-top: 20px;
  }
`

const ImgEl2 = styled.div`
  display: flex;
  align-items: flex-end;
  width: 136px;
  height: 164px;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: 16px 16px 32px rgba(0, 153, 76, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  position: absolute;
  left: 11%;
  top: 42%;
  transform: translateY(-50%);
`

const ImgEl3 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 182px;
  height: 208px;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: 16px 16px 32px rgba(0, 153, 76, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  position: absolute;
  top: 75px;
  right: 0;
`

const Title = styled.h1`
  color: ${color.neutral20};
  font-family: "Lato", sans-serif;
  font-size: 24px;
  line-height: 32px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 20px;
  max-width: 835px;

  @media (min-width: 576px) {
    font-size: 32px;
    line-height: 40px;
  }

  @media (min-width: 769px) {
    font-size: 60px;
    line-height: 72px;
  }

  span {
    color: ${color.secondary20};
  }
`
